import {useDebugValue} from 'react';

import classNames from 'classnames';

const componentClassNamespace = 'search-form';
const componentClassName = `${componentClassNamespace}__icon`;
const componentSmallClassName = `${componentClassName}--small`;
const componentLargeClassName = `${componentClassName}--large`;

function useComponent(props) {
    let {
        iconName
    } = props;

    const smallIconClassName = classNames(componentClassName, componentSmallClassName);
    const largeIconClassName = classNames(componentClassName, componentLargeClassName);

    iconName = `${iconName}`.toUpperCase().replace('-', '_');

    const smallIconId = `${iconName}__16`;
    const largeIconId = `${iconName}__24`;

    const {
        [smallIconId]: smallIconMarkup,
        [largeIconId]: largeIconMarkup
    } = require('@homeaway/svg-defs');

    const result = {
        smallIconClassName,
        largeIconClassName,
        smallIconMarkup,
        largeIconMarkup
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
